import React from "react";
import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "components/table";
import ErrorIcon from "@material-ui/icons/Error";
import { convertToBigNum } from "lib/generalUtility";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  table: {
    tableLayout: "auto",
    whiteSpace: "nowrap",
    borderCollapse: "separate",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
    },
    "& th,td": {
      fontSize: ".75rem",
      borderRight: "1px solid rgba(58, 77, 84, 0.1)",
      borderBottom: "none",
      padding: theme.spacing(1, 2, 1, 2),
    },
    "& th": {
      color: theme.palette.text.secondary,
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  tableContainer: {
    maxHeight: 200,
    overflowY: "auto",
    border: "1px solid rgba(0, 0, 0, 0.1);",
    borderRadius: 4,
  },
  emptyContainer: {
    maxHeight: 100,
    backgroundColor: theme.palette.background.paper,
    justifyContent: "center",
    border: "1px solid rgba(0, 0, 0, 0.1);",
    borderRadius: 4,
    display: "flex",
  },
  button: {
    display: "flex",
    alignItems: "center",
    padding: 0,
    minWidth: 0,
    marginLeft: theme.spacing(1),
  },
  iconBtn: {
    borderRadius: theme.spacing(0.5),
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shortest,
    }),
    padding: "3px 5px",
  },
}));

export default function InstantWinPrizeTableComponent({
  productDropdown,
  tableData,
  bonanza,
  percent,
  lang,
}) {
  const classes = useStyle();

  return (
    <>
      {tableData.length > 0 ? (
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  {getLang(lang, "label.IMAGE")}
                </StyledTableCell>
                <StyledTableCell>
                  {getLang(lang, "label.PRIZE")}
                </StyledTableCell>
                <StyledTableCell>
                  {getLang(lang, "label.QUANTITY")}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((item, index) => {
                return (
                  <StyledTableRow key={index} hover tabIndex={-1}>
                    <StyledTableCell>
                      <img
                        src={item.picture}
                        style={{ width: "30px", height: "30px" }}
                        alt={item.id}
                      />
                    </StyledTableCell>
                    <StyledTableCell>{item.name}</StyledTableCell>
                    <StyledTableCell>
                      {convertToBigNum(item.quantity)}
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box>
          <TableContainer
            className={classes.tableContainer}
            style={{ borderRadius: 0 }}
          >
            <Table className={classes.table} size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    {getLang(lang, "label.IMAGE")}
                  </StyledTableCell>
                  <StyledTableCell>
                    {getLang(lang, "label.PRIZE_NAME")}
                  </StyledTableCell>
                  <StyledTableCell>
                    {getLang(lang, "label.QUANTITY")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          <Box py={5} className={classes.emptyContainer}>
            <ErrorIcon style={{ paddingRight: 5 }}></ErrorIcon>
            <Typography variant="body1">
              {getLang(lang, "paragraph.NO_PRIZE_SET")}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
